// extracted by mini-css-extract-plugin
module.exports = {"QuestionContainer":"Question_QuestionContainer__3yVSe","Open":"Question_Open__24hSm","Question":"Question_Question__2lAdy","Answer":"Question_Answer__332Ot"};